import { render } from "./ReportSummaryMetric.vue?vue&type=template&id=4512fdb6&scoped=true"
import script from "./ReportSummaryMetric.vue?vue&type=script&lang=js"
export * from "./ReportSummaryMetric.vue?vue&type=script&lang=js"

import "./ReportSummaryMetric.vue?vue&type=style&index=0&id=4512fdb6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4512fdb6"]])

export default __exports__